import axios from 'axios';

/**
 * Unauthenticated axios instance for client portal endpoints.
 *
 * Client portal users authenticate via a token embedded in the URL path,
 * NOT via JWT headers. This instance intentionally has NO auth interceptor
 * to prevent leaking JWT tokens to unauthenticated endpoints.
 *
 * For JWT-authenticated requests, use secureApi instead.
 */
const clientApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Response interceptor — client-friendly error handling (no login redirect)
clientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          error.response.data = {
            message: 'رابط غير صالح — تواصل مع فريق الدعم',
            code: 'INVALID_TOKEN'
          };
          break;

        case 429:
          // Rate limit — keep original Arabic message from backend
          break;

        case 500:
          error.response.data = {
            message: 'حدث خطأ — يرجى المحاولة لاحقاً',
            code: 'SERVER_ERROR'
          };
          break;

        default:
          break;
      }
    }

    return Promise.reject(error);
  }
);

export { clientApi };
export default clientApi;
